import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import TestResultsMainHeader from '../../../components/TestResultsMainHeader';
import TreatmentPageContent from '../../components/TreatmentPageContent';

import { getTreatmentPage } from '../../actions/treatmentPage';

import './index.scss';

const TreatmentPage = ({
  lang,
  changeLanguage,
  data,
  error,
  loading,
  dispatch,
}) => {
  const { treatmentId } = useParams();

  useEffect(() => {
    dispatch(getTreatmentPage(treatmentId, lang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, treatmentId, lang]);

  if (loading) return <div className='product-page__loader'></div>;

  return (
    <div className='treatment-page'>
      <TestResultsMainHeader
        availableLanguages={['en', 'de', 'fr']}
        defaultLanguage={lang}
        onChangeLanguage={changeLanguage}
        dispatch={dispatch}
        logoClassName='treatment-page__logo'
      />

      {data && !error && (
        <div className='treatment-page__content'>
          <TreatmentPageContent data={data} dispatch={dispatch} />
        </div>
      )}
    </div>
  );
};

TreatmentPage.propTypes = {
  lang: PropTypes.string,
  changeLanguage: PropTypes.func,
  data: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => ({
  data: state.treatmentPage.get('data'),
  error: state.treatmentPage.get('error'),
  loading: state.treatmentPage.get('loading'),
});

export default connect(mapStateToProps)(TreatmentPage);
